import { Color } from "three";
import { BasePanel } from "./BasePanel";
import VUtil from "../VUILib/VUtils.js";
import { VVerticleLayout } from "../VUILib/UILayout/VLayout.js";

const bg = "/assets/vrUI/common/bg.png";
const titleBgPath = "/assets/vrUI/common/titleBg.png";
const btn_normalPath = "/assets/vrUI/common/btn_normal.png";
const btn_hoverPath = "/assets/vrUI/common/btn_hover.png";
const btn_clickPath = "/assets/vrUI/common/btn_click.png";
const closeIconPath = "/assets/vrUI/common/close.png";
const measure_normalPath = "/assets/vrUI/measurePanel/measure_normal.png";
const measure_hoverPath = "/assets/vrUI/measurePanel/measure_hover.png";
const measure_clickPath = "/assets/vrUI/measurePanel/measure_click.png";
const dropdownBgPath = "/assets/vrUI/measurePanel/dropdownBg.png";
const dropdownItemBgPath = "/assets/vrUI/measurePanel/dropdownItemBg.png";
const clearAllIconPath = "/assets/vrUI/measurePanel/clearIcon.png";

const delete_normalPath = "/assets/vrUI/measurePanel/delete_normal.png";
const delete_hoverPath = "/assets/vrUI/measurePanel/delete_hover.png";
const delete_clickPath = "/assets/vrUI/measurePanel/delete_click.png";

const view_normalPath = "/assets/vrUI/measurePanel/view_normal.png";
const view_hidePath = "/assets/vrUI/measurePanel/view_hide.png";

export class MeasurePanel extends BasePanel {
  constructor(manager, visible) {
    super(manager, visible);
  }

  async init() {
    const width = 1;
    const height = 1.2;

    this.isMeasuring = false;
    this.hideAll = false; // 是否隐藏所有测量结果
    this.measureUtil = this.manager.interface.measureUtil;

    // container
    const bgMap = await this.manager.loadManager.loadTexture(bg);
    const container = this.uilib.createContainer({
      color: 0x0b0c0c,
      map: bgMap,
      opacity: 1,
      width: width,
      height: height,
      radius: 0.025,
      dragable: true,
    });
    this.uilib.addUIToScene(container);
    container.visible = this._visible;
    container.position.x -= 0.5;
    //container.scale.set(0.5, 0.5, 0.5);

    this.uiElements.push(container);

    // title
    const title = this.uilib.createText({
      text: "测量",
      textColor: 0xafbbe3,
      textSize: 0.05,
      font: "bold",
      align: "left",
    });
    container.add(title);
    title.position.y = height / 2 - 0.08;
    title.position.x = -width / 2 + 0.08;

    // close btn
    const closeIcon = await this.manager.loadManager.loadTexture(closeIconPath);
    const closeBtn = this.uilib.createBtn({
      map: closeIcon,
      text: "",
      color: "#A8B4DB",
      width: 0.1,
      height: 0.1,
      radius: 0,
    });
    closeBtn.addHoverEnterEvent((obj) => {
      obj.material.color = new Color("#6275B5");
    });
    closeBtn.addHoverExitEvent((obj) => {
      obj.material.color = new Color("#A8B4DB");
    });
    closeBtn.addClickEvent((obj) => {
      this.closePanel();
    });
    container.add(closeBtn);
    closeBtn.position.z = 0.001;
    closeBtn.position.y = height / 2 - 0.08;
    closeBtn.position.x = width / 2 - 0.11;

    // titleBg
    this.manager.loadManager.loadTexture(titleBgPath, (tex) => {
      const titleBg = this.uilib.createImage({
        map: tex,
        width: width * 0.9,
        height: 0.1,
        radius: 0,
      });
      container.add(titleBg);
      titleBg.position.y = height / 2 - 0.1;
    });

    const btn_normal = await this.manager.loadManager.loadTexture(
      btn_normalPath
    );
    const btn_hover = await this.manager.loadManager.loadTexture(btn_hoverPath);
    const btn_click = await this.manager.loadManager.loadTexture(btn_clickPath);

    const measure_normal = await this.manager.loadManager.loadTexture(
      measure_normalPath
    );
    const measure_hover = await this.manager.loadManager.loadTexture(
      measure_hoverPath
    );
    const measure_click = await this.manager.loadManager.loadTexture(
      measure_clickPath
    );

    // 测量 btn
    const measureBtn = this.uilib.createBtn({
      map: this.isMeasuring ? measure_click : measure_normal,
      text: "",
      width: 0.14,
      height: 0.14,
      radius: 0,
      stateChangeImage: {
        click: measure_click,
        hover: measure_hover,
      },
    });
    measureBtn.addHoverEnterEvent((obj) => {});
    measureBtn.addHoverExitEvent((obj) => {
      obj.material.map = this.isMeasuring ? measure_click : measure_normal;
    });
    measureBtn.addClickEvent((obj) => {
      this.isMeasuring = !this.isMeasuring;
    });
    container.add(measureBtn);
    measureBtn.position.z = 0.001;
    measureBtn.position.x = -0.33;
    measureBtn.position.y = 0.35;

    // 单位 下拉菜单
    const dropdownBg = await this.manager.loadManager.loadTexture(
      dropdownBgPath
    );
    const itemBg = await this.manager.loadManager.loadTexture(
      dropdownItemBgPath
    );
    const dropdown = this.uilib.createDropdown({
      options: ["m", "cm", "mm"],
      defaultIndex: 0,
      map: dropdownBg,
      textSize: 0.06,
      textColor: 0xafbbe3,
      iconColor: 0xffffff,
      width: 0.25,
      height: 0.08,
      itemBgMap: itemBg,
      bgOpacity: 0,
      radius: 0,
      stateChangeColor: {
        normal: 0xffffff,
        hover: 0xafbbe3,
        click: 0x8993c3,
      },
      itemColor: 0xffffff,
      optionStageChangeColor: {
        normal: 0xffffff,
        hover: 0x8993c3,
      },
    });
    dropdown.addOnValueChangeEvent((index, str) => {
      this.onUnitChange(index, str);
    });
    container.add(dropdown);
    dropdown.position.z = 0.005;
    dropdown.position.x = 0.25;
    dropdown.position.y = 0.35;

    // line
    const line = this.uilib.createContainer({
      color: 0x787878,
      opacity: 0.7,
      width: width * 0.8,
      height: 0.0025,
      radius: 0,
      dragable: false,
    });
    container.add(line);
    line.renderOrder = 100000;
    line.position.y = 0.275;

    // 滚动视图
    const layout = new VVerticleLayout();
    layout.setSpacing(0.01);
    this.scrollview = this.uilib.createScrollViewVerticle({
      width: width * 0.9,
      height: 0.65,
      radius: 0,
      opacity: 0,
      sliderColor: 0xafbbe3,
      handleColor: 0x8993c3,
      sliderOpacity: 0.5,
      handleOpacity: 0.8,
      verticleLayout: layout,
      sliderExitState: "hide",
    });
    container.add(this.scrollview);
    this.scrollview.position.y = -0.08;

    this.delete_normal = await this.manager.loadManager.loadTexture(
      delete_normalPath
    );
    this.delete_hover = await this.manager.loadManager.loadTexture(
      delete_hoverPath
    );
    this.delete_click = await this.manager.loadManager.loadTexture(
      delete_clickPath
    );
    this.view_normal = await this.manager.loadManager.loadTexture(
      view_normalPath
    );
    this.view_hide = await this.manager.loadManager.loadTexture(view_hidePath);

    // 测量记录
    this.records = this.manager.interface.getAllMeasureRecord();

    this.recordItems = [];
    for (var i = 0; i < this.records.length; i++) {
      this.recordItems.push(this.addRecord(this.records[i]));
    }

    // 全部隐藏按钮
    {
      const allHideBtn = this.uilib.createBtn({
        map: btn_normal,
        text: "",
        width: 0.3,
        height: 0.08,
        radius: 0,
        stateChangeImage: {
          normal: btn_normal,
          hover: btn_hover,
          click: btn_click,
        },
      });
      allHideBtn.addHoverEnterEvent((obj) => {});
      allHideBtn.addHoverExitEvent((obj) => {});
      allHideBtn.addClickEvent((obj) => {
        this.measureUtil.setAllRecordVisible(this.hideAll);

        this.hideAll = !this.hideAll;

        if (!this.hideAll) {
          obj._showText.hide();
          obj._hideText.show();
        } else {
          obj._showText.show();
          obj._hideText.hide();
        }
        allHideBtn._icon.material.map = this.hideAll
          ? this.view_normal
          : this.view_hide;

        for (var i = 0; i < this.recordItems.length; i++) {
          this.recordItems[i]._viewBtn.material.map = this.hideAll
            ? this.view_hide
            : this.view_normal;
          this.recordItems[i]._record.visible = !this.hideAll;
        }
      });
      container.add(allHideBtn);
      allHideBtn.position.z = 0.001;
      allHideBtn.position.x = -0.2;
      allHideBtn.position.y = -0.48;

      const icon = this.uilib.createImage({
        renderOrder: 100000,
        map: this.hideAll ? this.view_normal : this.view_hide,
        width: 0.08,
        height: 0.08,
        radius: 0,
      });
      allHideBtn.add(icon);
      icon.position.x = -0.08;

      allHideBtn._icon = icon;

      const text1 = this.uilib.createText({
        text: "全部隐藏",
        textColor: 0xafbbe3,
        textSize: 0.035,
        font: "bold",
        align: "center",
      });
      allHideBtn.add(text1);
      text1.position.x = 0.035;

      const text2 = this.uilib.createText({
        text: "全部显示",
        textColor: 0xafbbe3,
        textSize: 0.035,
        font: "bold",
        align: "center",
      });
      allHideBtn.add(text2);
      text2.position.x = 0.035;

      if (this.hideAll) {
        text1.hide();
      } else {
        text2.hide();
      }

      allHideBtn._showText = text2;
      allHideBtn._hideText = text1;
    }

    // 全部清除按钮
    {
      const clearAllIcon = await this.manager.loadManager.loadTexture(
        clearAllIconPath
      );
      const allClearBtn = this.uilib.createBtn({
        map: btn_normal,
        text: "",
        width: 0.3,
        height: 0.08,
        radius: 0,
        stateChangeImage: {
          normal: btn_normal,
          hover: btn_hover,
          click: btn_click,
        },
      });
      allClearBtn.addHoverEnterEvent((obj) => {});
      allClearBtn.addHoverExitEvent((obj) => {});
      allClearBtn.addClickEvent((obj) => {
        this.measureUtil.removeAllRecords();

        for (var i = 0; i < this.recordItems.length; i++) {
          this.scrollview.removeContent(this.recordItems[i]);
        }
        this.recordItems = [];
      });
      container.add(allClearBtn);
      allClearBtn.position.z = 0.001;
      allClearBtn.position.x = 0.2;
      allClearBtn.position.y = -0.48;

      const icon = this.uilib.createImage({
        renderOrder: 100000,
        map: clearAllIcon,
        width: 0.08,
        height: 0.08,
        radius: 0,
      });
      allClearBtn.add(icon);
      icon.position.x = -0.06;

      const text = this.uilib.createText({
        text: "清空",
        textColor: 0xafbbe3,
        textSize: 0.035,
        font: "bold",
        align: "center",
      });
      allClearBtn.add(text);
      text.position.x = 0.035;
    }

    if (!this._visible) {
      this.hide();
    }
  }

  /**
   * 添加单条测量记录
   * @param {*} record
   * @returns
   */
  addRecord(record) {
    const container = this.uilib.createContainer({
      height: 0.1,
      width: 0.9,
      opacity: 0.0,
      radius: 0,
      dragable: false,
    });
    container._record = record;
    container.name = "测量记录";

    // view btn
    {
      const viewBtn = this.uilib.createBtn({
        map: !record.visible ? this.view_hide : this.view_normal,
        text: "",
        width: 0.1,
        height: 0.1,
        radius: 0,
        stateChangeColor: {
          click: 0x7a9adc,
          hover: 0xafbbe3,
        },
      });
      viewBtn.addHoverEnterEvent((obj) => {});
      viewBtn.addHoverExitEvent((obj) => {
        obj.material.color = new Color(0xffffff);
      });
      viewBtn.addClickEvent((obj) => {
        const tempRecord = obj._itemObj._record;
        const src = tempRecord.visible;

        this.measureUtil.setRecordVisibleById(tempRecord.id, !src);

        tempRecord.visible = !src;

        obj.material.map = !tempRecord.visible
          ? this.view_hide
          : this.view_normal;
      });
      viewBtn.name = "隐藏按钮";
      viewBtn._itemObj = container;
      container._viewBtn = viewBtn;
      container.add(viewBtn);
      viewBtn.position.z = 0.001;
      viewBtn.position.x = -0.35;
    }

    // delete btn
    {
      const deleteBtn = this.uilib.createBtn({
        map: this.delete_normal,
        text: "",
        width: 0.1,
        height: 0.1,
        radius: 0,
        stateChangeImage: {
          normal: this.delete_normal,
          click: this.delete_click,
          hover: this.delete_hover,
        },
      });
      deleteBtn.addHoverEnterEvent((obj) => {});
      deleteBtn.addHoverExitEvent((obj) => {
        obj.material.color = new Color(0xffffff);
      });
      deleteBtn.addClickEvent((obj) => {
        this.measureUtil.removeRecordById(obj._itemObj._record.id);

        this.records = this.measureUtil.getRecords();

        // 删除记录
        this.scrollview.removeContent(container);
        this.recordItems = this.recordItems.filter(
          (item) => item !== container
        );
      });
      deleteBtn.name = "删除按钮";
      deleteBtn._itemObj = container;
      container.add(deleteBtn);
      deleteBtn.position.z = 0.001;
      deleteBtn.position.x = 0.35;
    }

    // name text
    {
      const name = this.uilib.createText({
        text: record.name,
        textColor: 0xafbbe3,
        textSize: 0.04,
        font: "bold",
        align: "left",
        createdCB: (text) => {
          this.scrollview.setSomethingForLater(name);
        },
      });
      container.add(name);
      name.name = record.name;
      name.position.z = 0.001;
      name.position.x = -0.25;
    }

    // distance text
    {
      const str = this.measureUtil.getDisStr(record.distance);
      const distance = this.uilib.createText({
        text: str,
        textColor: 0xafbbe3,
        textSize: 0.04,
        font: "bold",
        align: "right",
        createdCB: (text) => {
          this.scrollview.setSomethingForLater(distance);
        },
      });
      distance.name = str;
      container.add(distance);
      distance.position.x = 0.25;
      container._distance = distance;
    }

    this.scrollview.addContent(container);
    return container;
  }

  /**
   * 单位改变事件
   * @param {*} index
   * @param {*} str
   */
  onUnitChange(index, str) {
    this.measureUtil.setUnit(str);

    for (var i = 0; i < this.recordItems.length; i++) {
      this.recordItems[i]._distance.clear();

      const distance = this.uilib.createText({
        text: this.measureUtil.getCurrentDisStrById(
          this.recordItems[i]._record.id
        ),
        textColor: 0xafbbe3,
        textSize: 0.04,
        font: "bold",
        align: "right",
        createdCB: (text) => {
          this.scrollview.setSomethingForLater(distance);
        },
      });
      this.recordItems[i].add(distance);
      distance.position.x = 0.25;
      this.recordItems[i]._distance = distance;
    }
  }

  /**
   * 更新测量面板
   * @param {*} records
   */
  updateRecords(records) {
    // 只需要对增加进行更新
    if (records.length > this.records.length) {
      this.scrollview.clearContent();

      this.records = records;
      this.recordItems = [];
      for (var i = 0; i < this.records.length; i++) {
        this.recordItems.push(this.addRecord(this.records[i]));
      }
    }
  }

  closePanel() {
    super.closePanel();

    this.manager.interface.setClickMode(0); // 切换到默认模式
  }

  show() {
    super.show();

    this.manager.interface.setClickMode(1); // 切换到测量模式
  }
}
